$('.sameHeight2').matchHeight();
$('.sameHeight1').matchHeight();
$('.sameHeight3').matchHeight();
$('.sameHeight4').matchHeight();
$('.sameHeight5').matchHeight();
$('.sameHeight6').matchHeight();

$('.lightgallery').lightGallery();

$('.header__subpage').css('margin-top',$('.header__nav').height() + 'px')
$('.header__home__slider').css('margin-top',$('.header__nav').height() + 'px')
$(function() {

    $('#rasgal').lightGallery({
        selector: '.rasgal_selector'
    });

    $('#refgal').lightGallery({
        selector: '.gal_selector'
    });

    //// Header Shrin on Scroll ////
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > 50) {
        $('.language-nav--desktop').addClass("shrink");
        $('.header__nav__schneider-logo').addClass("shrink");
        $('.header__nav__desktop').addClass("shrink");
      } else {
        $('.language-nav--desktop').removeClass("shrink");
        $('.header__nav__schneider-logo').removeClass("shrink");
        $('.header__nav__desktop').removeClass("shrink");
      }
    });
    $(window).on('resize',function(){
        $('.header__subpage').css('margin-top',$('.header__nav').height() + 'px')
        $('.header__home__slider').css('margin-top',$('.header__nav').height() + 'px')
    })
    ////// Text-Switcher ////
    // Function to switch Text of $this.Element and Toggle .next().sibling
    // Beispiel: Button: Öffnen/Schliessen mit nachfolgendem Formular

    function clickTextSwitcher(target, child, slider) {
        $(target).click(function() {
          if (slider == true) { 
            $(this).parent().find(child).slideToggle(200); };
            $(this).html($(this).html() == $(this).data('open') ? $(this).data('close') : $(this).data('open'));
        });
    }

    var main_slider = new Swiper('.main_slider', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        direction: 'horizontal',
        speed: 750,
        effect: 'slide',
        grabCursor: true,
        autoplay: 6000,
        loop: true,
        reloadImages: false,
        lazy: true
    });

    var subpage_header_slider = new Swiper('.subpage_header_slider', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        direction: 'horizontal',
        speed: 750,
        effect: 'slide',
        grabCursor: true,
        autoplay: 6000,
        loop: true,
        reloadImages: false,
        lazy: true
    });

    var referenzslider = new Swiper('.referenz_slider', {
      pagination: '.swiper-pagination',
      paginationClickable: true,
      direction: 'horizontal',
      speed: 750,
      effect: 'slide',
      grabCursor: true,
      autoplay: 6000,
      loop: true,
      reloadImages: false,
      lazy: true
    });

    var content_slider = new Swiper('.content_slider', {
      speed: 750,
      effect: 'slide',
      grabCursor: true,
      loop: true,
      autoplay: 6000
    });

    // Look for .hamburger
    var hamburger = document.querySelector(".hamburger");
    // On click
    hamburger.addEventListener("click", function() {
        // Toggle class "is-active"
        hamburger.classList.toggle('is-active');
        // Do something else, like open/close menu
        $("#mobilenav").slideToggle(200);
    });

    $(window).resize(function() {
      if ($(window).width() >= 800) {
        $("#mobilenav").hide();
        hamburger.classList.remove("is-active");
      };
    });

    $('#hidden-content-btn').click(function(e) {
      e.preventDefault();
      if ($('#hidden-content').hasClass('show')) {
        $('#hidden-content').removeClass('show');
        $('#hidden-content-btn').html('Mehr lesen');
      } else {
        $('#hidden-content').addClass('show');
        $('#hidden-content-btn').html('Weniger');
      }
    });

});